import { AppointmentType } from "@/types/diary/AppointmentType";
import displayErrorMessage from "../ErrorHandling";

const validateAttendees = async (
  appointmentType: AppointmentType,
  attendeeCount: number,
  propertyCount: number,
) => {
  const errors: string[] = [];

  // Set descriptions for error messages so they read better to the end user
  const attendeeDescription =
    appointmentType.requiresContact > 1 ? "attendees" : "attendee";
  const propertyDescription =
    appointmentType.requiresProperty > 1 ? "properties" : "property";

  // For better UX, rather than just returning a generic error, we should tell the user what's failed
  if (attendeeCount < appointmentType.requiresContact) {
    errors.push(
      `This appointment must have at least ${appointmentType.requiresContact} ${attendeeDescription}.`,
    );
  }

  if (propertyCount < appointmentType.requiresProperty) {
    errors.push(
      `This appointment must have at ${appointmentType.requiresProperty} ${propertyDescription}.`,
    );
  }

  if (!errors.length) {
    return true;
  }

  await displayErrorMessage(errors.join("\n\n"));

  return false;
};

export { validateAttendees };
